import TableVisualization from '@/blocks/analytics-block/visualizations/table-visualization.example';

export default TableVisualization;
